import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2fd41f6b")

_pushScopeId("data-v-2fd41f6b")
const _hoisted_1 = {
  key: 0,
  class: "text-red-lp-100"
}
const _hoisted_2 = {
  key: 0,
  class: "pointer-events-none relative inset-y-0 right-0 flex items-center px-2"
}
const _hoisted_3 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_4 = {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: ["inline-block relative bottom-0 left-0 text-12px xxl:text-14px", `${_ctx.isCustomWidth ? '' : 'w-full'} ${_ctx.customClassHeight}`],
    tabindex: !_ctx.isFocusable ? '-1' : '0',
    onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
    onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.isExpand !== ''
            ? _ctx.isExpand && _ctx.openSelect && !_ctx.isDisabled
              ? _ctx.expandUpwards
                ? `rounded-b${_ctx.customBorderRadius}`
                : `rounded-t${_ctx.customBorderRadius}`
              : `rounded${_ctx.customBorderRadius}`
            : _ctx.openSelect && !_ctx.isDisabled
            ? _ctx.expandUpwards
              ? `rounded-b${_ctx.customBorderRadius}`
              : `rounded-t${_ctx.customBorderRadius}`
            : `rounded${_ctx.customBorderRadius}`
        } ${_ctx.customClassField} ${
          _ctx.isDisabled
            ? 'cursor-not-allowed text-gray-lp-600'
            : 'cursor-pointer text-black-lp-300'
        }
         ${_ctx.error ? 'border-red-lp-100' : `${_ctx.customBorderColor}`} ${
          _ctx.disableBackground ? 'bg-gray-lp-1500' : ''
        } flex items-center border leading-tight px-3 py-2 xxl:py-2.5 font-normal truncate h-full`
      ,
      style: `${_ctx.customStyleField}`,
      onClick: _cache[1] || (_cache[1] = () => (_ctx.openSelect ? _ctx.closeSelect() : _ctx.expandSelect()))
    }, [
      _renderSlot(_ctx.$slots, "label", { label: _ctx.selectedItem }, () => [
        _createVNode("span", {
          class: 
            `align-middle truncate w-full ${_ctx.placeholderStyle} ${_ctx.customValueStyle}`
          
        }, [
          _createVNode("span", {
            innerHTML: 
              !_ctx.value.length
                ? _ctx.selectedItem?.name || _ctx.defaultValue || _ctx.placeholder
                : _ctx.value
            
          }, null, 8, ["innerHTML"]),
          (_ctx.counter)
            ? (_openBlock(), _createBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.counter) + ")", 1))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.selectedItem?.isChip)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: _ctx.selectedItem?.chipStyle,
              innerHTML: _ctx.selectedItem?.chipLabel
            }, null, 10, ["innerHTML"]))
          : _createCommentVNode("", true),
        (_ctx.customChips)
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: `${_ctx.customChips} ${_ctx.selectedItem?.chipStyle} self-center py-0.5 mr-2`,
              innerHTML: _ctx.selectedItem?.chipLabel
            }, null, 10, ["innerHTML"]))
          : _createCommentVNode("", true)
      ], true),
      (!_ctx.isDisabled || _ctx.isCustomChevronDisable)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.isExpand !== '' ? _ctx.isExpand && _ctx.openSelect : _ctx.openSelect)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _imports_0,
                  class: `w-4 ${_ctx.customChevronStyle}`,
                  alt: "chevron-up"
                }, null, 2))
              : (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _imports_1,
                  class: `w-4 ${_ctx.customChevronStyle}`,
                  alt: "chevron-down"
                }, null, 2))
          ]))
        : _createCommentVNode("", true)
    ], 6),
    (
        _ctx.isExpand !== ''
          ? _ctx.isExpand && _ctx.openSelect && !_ctx.isDisabled
          : _ctx.openSelect && !_ctx.isDisabled
      )
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["select w-full bg-white border pr-1 pl-4 py-1 z-50 flex-row", 
        `${_ctx.expandUpwards ? `border-b-0 rounded-t${_ctx.customBorderRadius}` : `border-t-0 rounded-b${_ctx.customBorderRadius}`} ${_ctx.customClassExpand} ${_ctx.customBorderColor}`
      ],
          style: `${_ctx.expandUpwards ? 'bottom: 40px' : ``}`
        }, [
          (_ctx.options.length > 0)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "options w-full flex flex-col gap-y-4 text-black-lp-300 overflow-auto pr-3 py-1.5 px-2",
                style: `${_ctx.isCustomMaxHeight ? '' : `max-height: 200px`}`
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `${index}`,
                    class: [
            {'text-red-lp-100 selected': _ctx.isActive(option)},
            {'cursor-not-allowed text-gray-lp-600': option?.disabled},
            {'cursor-pointer hover:text-red-lp-100': !option?.disabled},
            `${_ctx.customOptionStyle} flex justify-between align-middle items-center`]
          ,
                    onClick: () => _ctx.onSelect(option)
                  }, [
                    _renderSlot(_ctx.$slots, "option", { option: option }, () => [
                      _createVNode("span", {
                        innerHTML: option.name
                      }, null, 8, ["innerHTML"]),
                      _withDirectives(_createVNode("img", {
                        src: require(`@/app/ui/assets/svg/check-red.svg`),
                        class: "w-6 max-w-none",
                        alt: "check-red"
                      }, null, 8, ["src"]), [
                        [_vShow, _ctx.isCheck && _ctx.isActive(option)]
                      ]),
                      (_ctx.customChips)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: `${_ctx.customChips} ${option.chipStyle}`,
                            innerHTML: option.chipLabel
                          }, null, 10, ["innerHTML"]))
                        : _createCommentVNode("", true)
                    ], true)
                  ], 10, ["onClick"]))
                }), 128))
              ], 4))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 6))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode("img", _hoisted_4, null, 512), [
        [_vShow, _ctx.errorCaption]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.errorCaption), 1)
    ], 512), [
      [_vShow, _ctx.error]
    ])
  ], 42, ["tabindex"])), [
    [_directive_click_outside, () => _ctx.closeSelect()]
  ])
})